import { TYPES_ACTION } from '../../services/journalActiviteService';
import i18n from '../../i18n';

/**
 * Ce qu'une ligne du journal annonce, SANS jamais nommer de route.
 *
 * POURQUOI PLUS AUCUN CHEMIN. Le journal affichait le chemin complet de chaque
 * requete, puis - apres un premier passage - sa seule ressource. Il n'en montre
 * plus rien. Un chemin expose deux choses a quiconque peut lire le journal : la
 * cartographie du serveur, et les identifiants des dossiers consultes.
 *
 * POURQUOI CETTE FONCTION EXISTE. Le chemin servait de filet quand la
 * description manquait - les enregistrements anterieurs n'en portent pas. Le
 * retirer sans rien mettre a sa place aurait produit des lignes vides, et un
 * journal d'audit qui n'annonce rien ne prouve rien.
 *
 * L'ORDRE DES REPLIS. La description d'abord, parce qu'elle est ecrite pour etre
 * lue. Puis l'action et le module, qui suffisent a reconnaitre l'evenement. Puis
 * une phrase neutre, jamais le vide.
 */
// Lue a l'appel (journalActivite.json), dans la langue de l'ecran.
const neutre = () => i18n.t('journalActivite:valeurs.actionEnregistree');

const texte = (v) => (typeof v === 'string' ? v.trim() : '');

export function libelleEvenement(rec) {
  if (!rec) return neutre();

  const description = texte(rec.description);
  if (description) return description;

  /* Une action inconnue du catalogue s'affiche TELLE QUELLE. Le catalogue du
     front est un miroir de l'enum du serveur : un type ajoute la-bas et pas ici
     est precisement l'evenement nouveau qu'on vient regarder. Le laisser en blanc
     le rendrait invisible. */
  const action = texte(rec.typeAction)
    ? (TYPES_ACTION[rec.typeAction]?.label || rec.typeAction)
    : '';
  const module = texte(rec.module);

  if (action && module) return action + ' · ' + module;
  return action || module || neutre();
}
